import React, { useState } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

const HelpModal = () => {
  const [open, setOpen] = useState(false);
  return (
    <Modal
      open={open}
      trigger={
        <Button floated="right" onClick={() => setOpen(true)} compact>
          ?
        </Button>
      }
      onClose={() => setOpen(false)}
    >
      <Modal.Header>Help: Making Sense</Modal.Header>
      <Modal.Content scrolling>
        <Modal.Description>
          <Header>IIIF Standard</Header>
          <p>
            This is our help text for the canvas + annotation interface. More
            information can be found at:
            https://gitlab.com/brillpublishers/arkyves-frontend/issues/11
          </p>
          <Header>Open Annotations</Header>
          <p>
            This is our help text for the canvas + annotation interface. More
            information can be found at:
            https://gitlab.com/brillpublishers/arkyves-frontend/issues/11
          </p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} primary>
          Close <Icon name="chevron right" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default HelpModal;
